/**
 * Rental reservation record category values
 */
export enum RentalReservationRecordCategoryEnum {
	VEHICLE = 'vehicle',
	VEHICLE_CATEGORY = 'vehicle_category',
}
